import React, { useContext, useState } from "react";

import "./GlassyTheme.css";

import {
  MenuOutlined,
  QrcodeOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import { downArrow, upArrow } from "../Common/SvgIcon";
import { swipeUparrow, swipeDown1 } from "../Common/SvgIcon";
import {
  defaultBackgroundImage,
  defaultProfileImage,
} from "../Common/DefaultImage";
import { FloatButton } from "antd";
import { FaExchangeAlt, FaLocationArrow } from "react-icons/fa";
// import QRModal from "../Common/QRModal";
import HighlightImage from "../Common/highlightImagesCards/HighlightImage";
import SlideSocialMedia from "../Common/socialMedia/SlideSocialMedia";
import { HighlightImageValid, SocialMediaValid } from "../Common/DivValidation";
import { Link } from "react-router-dom";
import ProfileCardUltra from "../Common/profileCards/ProfileCardUltra";
import ProfileCardGlassy from "../Common/profileCards/ProfileCardGlassy";
import WebsiteUltra from "../Common/websiteCards/WebsiteUltra";
import ReviewCardUltra from "../Common/reviewCards/ReviewCardUltra";
import DownloadCardUltra from "../Common/fileDownloadsCards/DownloadCardUltra";
import ContactCardGlassy from "../Common/contactCards/ContactCardGlassy";
import SlideSocialMedias from "../Common/socialMedia/SlideSocialMedias";
import WebsiteBasic from "../Common/websiteCards/WebsiteBasic";
import VerticalSlideSMVex from "../Common/socialMedia/VerticalSlideSMVex";
import ReviewCardBasic from "../Common/reviewCards/ReviewCardBasic";
import HorsizontalscrollGlassy from "../Common/socialMedia/HorsizontalscrollGlassy";
import DownloadBasic from "../Common/fileDownloadsCards/DownloadBasic";
import ExchangeContact from "../Common/exchangeContactModal/ExchangeContact";
import { CardContext } from "../../store/CardContext";
import Footer from "../Common/footer/Footer";
import QRModal from "../Common/qrModals/QRModal";

const exchangeButton = (


  // <span
  //   className="flex items-center justify-center h-14 w-[60px] md:w-[60px] border border-black bg-white rounded-[10px] px-4 relative "
  // >
  //   <FaExchangeAlt size={18} color="black" />
  // </span >

  <span
    className="flex items-center justify-center h-14 w-[60px] md:w-[60px] border  bg-white rounded-[10px] px-4 relative"
    style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)' }} // Adjust opacity value (0.5 for 50% opacity)
  >
    <FaExchangeAlt size={18} color="black" />
  </span>
)

function GlassyTheme({ preview, card }) {
  const [cardData] = useContext(CardContext)


  const {
    profileImage,
    backgroundImage,
    personalDetails,
    checkProfile,
    contactDetails,
    socialMedias,
    website,
    review,
    fileName,
    files,
    // file1,
    // file2,
    // file3,
    // file4,
    SMediaPostion,
    companyLogo,
    checkLogo,
    vCard,
    checkExchangeContact,
    exchangeContact,
    footerText
    // files

  } = cardData




  // const files = {
  //   file1: file1,
  //   file2: file2,
  //   file3: file3,
  //   file4: file4,
  // };

  const exchangeButton = (

    <span
      className="flex items-center justify-center "

    >
      <FaExchangeAlt size={14} color="black" />
    </span >
  )



  const [isExpanded, setIsExpanded] = useState(false);
  const [qrModal, setQrModal] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          text: "Please check it out.",
          url: window.location.href,
          title: "ZEEQR",
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    }
  };

  const handleClose = (e) => {
    setQrModal(false);
  };

  const HighlightImageCheck = HighlightImageValid();
  const SocialMediaImageCheck = SocialMediaValid();
  console.log(profileImage);

  // const pfImage = profileImage?.thumbUrl &&
  //   profileImage?.status !== "removed" ? (
  //   profileImage?.originFileObj?.type
  //     ? URL.createObjectURL(
  //       profileImage?.originFileObj
  //     )
  //     : profileImage.thumbUrl
  // ) : defaultProfileImage
  const pfImage = profileImage ? profileImage : defaultProfileImage
  const imageStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: `url(${pfImage})`,
    backgroundRepeat: "no-repeat",
    // backgroundAttachment: "sticky"
  };


  return (
    <>

      <div className="digitalcontainer6 ">
        <div className="digitalcontainer_center6  ">
          <div className="digitalcontainer_banner6 relative h-screen overflow-auto scrollbar-hide  "
            style={imageStyle}
          >
            <div className='w-full'>

              {/* {profileImage[0]?.thumbUrl &&
                                profileImage[0]?.status !== "removed" ? (
                                <img
                                    className='min-h-screen sticky top-0 w-[380px]'
                                    src={
                                        profileImage[0]?.originFileObj?.type
                                            ? URL.createObjectURL(
                                                profileImage[0]?.originFileObj
                                            )
                                            : profileImage[0].thumbUrl
                                    }
                                    alt=""
                                />
                            ) : (
                                <img className='min-h-screen sticky w-[380px]' src={defaultProfileImage} alt="" />
                            )} */}
            </div>
            <div className="glassythemedetails">
              <div className="flex justify-end">
                <div className="fixed top-5 m-5">
                  <Link className="flex gap-2 h-[40px] "
                    to={`${preview ? contactDetails?.locationUrl : ""}`}
                    target={`${preview ? "_blank" : ""}`}
                  >
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.11425 10.0068H7.1611C6.6431 10.0068 6.14631 10.2126 5.78002 10.5789C5.41374 10.9451 5.20796 11.4419 5.20796 11.9599V21.335C5.20796 21.853 5.41374 22.3498 5.78002 22.7161C6.14631 23.0824 6.6431 23.2882 7.1611 23.2882H18.88C19.398 23.2882 19.8948 23.0824 20.2611 22.7161C20.6274 22.3498 20.8331 21.853 20.8331 21.335V11.9599C20.8331 11.4419 20.6274 10.9451 20.2611 10.5789C19.8948 10.2126 19.398 10.0068 18.88 10.0068H16.9268M9.11425 6.88176L13.0205 2.97546M13.0205 2.97546L16.9268 6.88176M13.0205 2.97546V16.3057" stroke="white" stroke-width="1.56252" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </Link>
                </div>
              </div>

              <div
                className={`  left-0 right-0 transform transition-transform ease-in-out  absolute  duration-300 ${isExpanded ? "translate-y-0 m-0 top-[0px]  " : "translate-y-0 top-[300px]"
                  }`}
              >
                <div className="profilecard6  justify-between" style={{ marginTop: "-1px" }}>
                  <div className="flex justify-center pt-10 items-center">
                    <div className="cursor-pointer" onClick={toggleExpand}>
                      {isExpanded ? swipeDown1 : swipeUparrow}
                    </div>
                  </div>

                  <div className="info">
                    <ProfileCardGlassy preview={preview} />
                  </div>
                  <div className={`flex gap-3 m-[15px] ${personalDetails?.about && socialMedias && socialMedias.length !== 0 ? 'justify-between' : 'justify-center'}`}>
                    <div>
                      <ContactCardGlassy preview={preview} />
                    </div>
                    <div>
                      {personalDetails?.about ? (
                        <div className="bg-[#D9D9D933] rounded-[16px] p-3 mb-4"> {/* Added mb-4 class for margin bottom */}
                          <p className="text-white text-[19px] font-bold text-center">About</p>
                          <div className="text-center m-[15px]">
                            <p className="text-white text-[12px] font-medium whitespace-pre-line">
                              {personalDetails.about}
                            </p>
                          </div>
                        </div>
                      ) : null}

                      {(socialMedias && socialMedias.length !== 0) ?
                        <div className="bg-[#D9D9D933] rounded-[16px] pt-3 pb-1">
                          <HorsizontalscrollGlassy preview={preview} limit={4} arrow={"20px"} widthsize={"100px"} />
                        </div>
                        : ''
                      }
                    </div>
                  </div>

                  {isExpanded && (
                    <div>
                      <div className=" bg-[#D9D9D933] rounded-[16px] m-[15px]">
                        {website[0]?.websiteName ?
                          <>

                            <div className="p-3">
                              <h3 className="text-start mt-[20px] text-[20px] text-white font-semibold uppercase">
                                Website
                              </h3>
                              <WebsiteBasic preview={preview} color={'white'} />
                            </div>
                          </>
                          : ''
                        }
                        {review[0]?.reviewName ?
                          <>

                            <div className="p-3">
                              <h3 className="text-start mt-[5px] text-[20px] text-white font-semibold uppercase">
                                Review
                              </h3>
                              <ReviewCardBasic review={review} preview={preview} color={'white'} />
                            </div>
                          </>
                          : ''
                        }
                      </div>
                      <div className=" bg-[#D9D9D933] rounded-[16px] m-[15px]">

                        {fileName?.fileName1 || fileName?.fileName2 || fileName?.fileName3 || fileName?.fileName4 ?
                          <>

                            <div className="p-3">
                              <h3 className="text-start mt-[20px] text-[20px] text-white font-semibold uppercase">
                                Downloads
                              </h3>
                              <DownloadBasic files={files} fileName={fileName} preview={preview} color={"white"} />
                            </div>
                          </>
                          : ''
                        }

                      </div>

                      <div className={`${HighlightImageCheck ? 'bg-[#D9D9D933] rounded-[16px] m-[15px]' : ''}`}>
                        <div className="text-start m-[15px] mb-0">
                          <p className="text-white text-[20px] pt-5 font-semibold">
                            {HighlightImageCheck ? "Gallery" : ""}
                          </p>
                          <div className="grid gap-2 grid-cols-2 items-center p-3 ">
                            {HighlightImageCheck && <HighlightImage preview={preview} />}
                          </div>
                        </div>
                      </div>


                      {/*  --------------------------------- footer ---------------------------------  */}
                      {footerText &&
                        <Footer color={"#ffffff"} />
                      }
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* {checkExchangeContact && (
            <div className="md:w-[60px] bottom-6 sm:bottom-4 md:bottom-6 lg:bottom-12 z-10 fixed  w-[60px] h-14 justify-center  ml-[140px]"
            >
              <ExchangeContact customButton={exchangeButton} details={exchangeContact} />
            </div>
          )} */}

          {/* {card?.exchangeContact?.show ?
            <ExchangeContact customButton={exchangeButton} details={card?.exchangeContact} cardId={card._id} />
            : ""
          } */}

        </div>
        {
          preview ?


            <FloatButton.Group className="shadow-xl"
              trigger="click"
              color="black share_button"
              style={{
                left: "50%",
                color: "white",
                position: "fixed",
                bottom: 20,
                marginLeft: '-20px',

              }}
              icon={<MenuOutlined />}
            >

              {card?.exchangeContact?.show ? (
                <div onClick={(e) => e.stopPropagation()} className='mb-[12px]'>
                  <FloatButton
                    icon={
                      <ExchangeContact
                        customButton={exchangeButton}
                        details={card?.exchangeContact}
                        cardId={card._id}
                      />
                    }
                  />
                </div>
              ) : (
                ""
              )}
              <FloatButton
                icon={<ShareAltOutlined />}
                onClick={handleShare}
              />
              <FloatButton
                icon={<QrcodeOutlined />}
                onClick={() => setQrModal(true)}
              />
              <Link to={contactDetails?.locationUrl} target={`${preview ? "_blank" : ""}`}>
                <FloatButton icon={<FaLocationArrow />} />
              </Link>

            </FloatButton.Group>

            : ""}
        {qrModal ? <QRModal handleClose={handleClose} /> : null}
      </div>

    </>
  );
}

export default GlassyTheme;
